<template>
  <div class="header-container" :class="{'has-logo':showLogo}">
    <logo class="logo-wrapper" v-if="showLogo" :collapse="isCollapse" />
    <div class="right-menu">
      <template v-if="device!=='mobile'">
        <search id="header-search" class="right-menu-item" />

        <error-log class="errLog-container right-menu-item hover-effect" />

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <el-tooltip content="Global Size" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip>
      </template>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <div class="name-wrap">
            你好！{{user.name}}
          </div>
          <img :src="user.avatar+'?imageView2/1/w/80/h/80'" class="user-avatar">
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/profile/index">
            <el-dropdown-item>个人中心</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Logo from '../Sidebar/Logo'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'
export default {
  name: "HeaderMenu",
  components: {
    Logo,
    ErrorLog,
    Screenfull,
    SizeSelect,
    Search
  },
  data() {
      return {
        activeIndex: '1',
      }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'user',
      'device',
      'permission_routes',
      'permission_routes_global'
    ]),
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    show: {
      get() {
        return this.$store.state.settings.showRightPanel
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
            key: 'fixedHeader',
            value: val
        })
      }
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/Logout')
      this.$store.dispatch('tagsView/delAllViews',).then(({visitedViews}) => {
        console.log(visitedViews)
      })
      this.$router.push(`/login`)
      location.reload()
    },
  }
}
</script>

<style  lang="scss" scoped>
@import "~@/styles/variables.scss";
.header-container{
  height: 50px;
  width: 100%;
  padding: 0 15px;
  overflow: hidden;
  position: fixed;
  background: $topHeaderBg;
  z-index: 1002;
  -webkit-box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  .logo-wrapper{
    float: left;
  }
  /deep/ .el-scrollbar{
    float: left;
    width: 55vw;
    padding-left: 2%;
  }
  .menu-warpper{
    /deep/ .el-menu-item{
      height: 50px;
      line-height: 50px;
    }

    /deep/ .el-submenu{
       .el-submenu__title{
         height: 50px;
         line-height: 50px;
       }
    }
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #ffffff;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .name-wrap {
          display: inline-block;
          height: 100%;
          font-size: 14px;
          vertical-align: top;
          margin-top: -5px;
        }
        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}

</style>

